import FireWorksMaterial from './FireWorksMaterial'
import { forwardRef } from 'react'

export default forwardRef(function FireWorks({ position = [3, 10, 0] }, ref) {
  return (
    <mesh ref={ref} frustumCulled={false} position={[position]}>
      <planeGeometry args={[2, 2, 1, 1]} />
      <FireWorksMaterial />
    </mesh>
  )
})
